import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.programs');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-support-programs',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportProgramsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public loaded: boolean = false;
    public page: number = 1;
    public lastpage: number = 1;
    public total: number = 0;
    public groupTab: string = 'active';   // active / completed / all  (FN-20260508-0006)
    public statusFilter: string = '';
    public categoryFilter: string = '';
    public agencyFilter: string = '';
    public searchText: string = '';
    public sortBy: string = 'recent';     // recent / apply_end / program_start

    public showCreate: boolean = false;
    public newItem: any = this._emptyItem();

    public statusMap: any = {
        draft: { label: '준비중', cls: 'bg-zinc-100 text-zinc-600' },
        recruiting: { label: '모집중', cls: 'bg-blue-100 text-blue-700' },
        evaluating: { label: '평가중', cls: 'bg-amber-100 text-amber-700' },
        operating: { label: '운영중', cls: 'bg-emerald-100 text-emerald-700' },
        completed: { label: '완료', cls: 'bg-zinc-200 text-zinc-700' },
        closed: { label: '종료', cls: 'bg-zinc-300 text-zinc-700' },
    };

    public categoryOptions: string[] = [
        '예비창업', '초기창업', '딥테크'
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    private _emptyItem() {
        return {
            title: '', code: '', category: '', _categorySelect: '', agency: '',
            description: '', target: '', benefits: '',
            per_company_budget: 0,
            apply_end: '', program_start: '', program_end: '',
            status: 'draft'
        };
    }

    public onCategoryChange(item: any) {
        if (item._categorySelect === '__custom__') {
            item.category = '';
        } else {
            item.category = item._categorySelect || '';
        }
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call('search', {
            page: this.page,
            group: this.groupTab === 'all' ? '' : this.groupTab,
            status: this.statusFilter,
            category: this.categoryFilter,
            text: this.searchText,
        });
        if (code == 200) {
            this.items = data.rows || [];
            // 클라이언트 사이드 정렬/필터(주관기관)
            if (this.agencyFilter) {
                this.items = this.items.filter(x => (x.agency || '').includes(this.agencyFilter));
            }
            if (this.sortBy === 'apply_end') {
                this.items.sort((a, b) => (a.apply_end || '').localeCompare(b.apply_end || ''));
            } else if (this.sortBy === 'program_start') {
                this.items.sort((a, b) => (b.program_start || '').localeCompare(a.program_start || ''));
            }
            // D-day 계산
            const today = new Date();
            today.setHours(0,0,0,0);
            for (const it of this.items) {
                it._dday = this._calcDday(it, today);
            }
            this.lastpage = data.lastpage || 1;
            this.total = data.total || 0;
        }
        this.loaded = true;
        await this.service.render();
    }

    private _calcDday(item: any, today: Date): string {
        const target = (item.status === 'recruiting') ? item.apply_end :
                       (item.status === 'operating' || item.status === 'evaluating') ? item.program_end : '';
        if (!target) return '';
        const t = new Date(target);
        if (isNaN(t.getTime())) return '';
        const diff = Math.ceil((t.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
        if (diff > 0) return `D-${diff}`;
        if (diff === 0) return 'D-Day';
        return `D+${-diff}`;
    }

    public async setGroupTab(g: string) {
        this.groupTab = g;
        this.page = 1;
        await this.load();
    }

    public async resetFilter() {
        this.statusFilter = '';
        this.categoryFilter = '';
        this.agencyFilter = '';
        this.searchText = '';
        this.sortBy = 'recent';
        this.page = 1;
        await this.load();
    }

    public async setPage(p: number) {
        if (p < 1 || p > this.lastpage) return;
        this.page = p;
        await this.load();
    }

    public openCreate() {
        this.newItem = this._emptyItem();
        this.showCreate = true;
        this.service.render();
    }

    public closeCreate() {
        this.showCreate = false;
        this.service.render();
    }

    public async submitCreate() {
        if (!this.newItem.title) {
            this.service.alert.show({ title: '입력 오류', message: '지원사업명을 입력하세요.', action: '확인' });
            return;
        }
        // Strip empty date strings → null for backend
        const payload: any = { ...this.newItem };
        delete payload._categorySelect;
        ['apply_end','program_start','program_end'].forEach(k => {
            if (!payload[k]) payload[k] = null;
        });
        payload.per_company_budget = Number(payload.per_company_budget) || 0;

        const { code, data } = await wiz.call('create', { data: JSON.stringify(payload) });
        if (code != 200) {
            this.service.alert.show({ title: '등록 실패', message: data?.message || '등록에 실패했습니다.', action: '확인' });
            return;
        }
        this.showCreate = false;
        await this.load();
    }

    public async remove(item: any) {
        const ok = await this.service.alert.show({
            title: '지원사업 삭제',
            message: `"${item.title}" 지원사업을 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        const { code, data } = await wiz.call('remove', { id: item.id });
        if (code != 200) {
            this.service.alert.show({ title: '삭제 실패', message: data?.message || '삭제 실패', action: '확인' });
            return;
        }
        await this.load();
    }

    public goItem(item: any) {
        this.service.href(`/admin/support/programs/${item.id}/info`);
    }

    public statusInfo(s: string) {
        return this.statusMap[s] || { label: s || '-', cls: 'bg-zinc-100 text-zinc-600' };
    }

    public formatMoney(n: any): string {
        const v = Number(n) || 0;
        return v.toLocaleString();
    }
}

export default PortalLpsysadminSupportProgramsComponent;